"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _theming = require("../theming");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// This uses a modified "lobotomized owl selector".
// It selects all elements that are immediate children
// of the component `& > …`
// And then uses the universal selector `*` with the
// adjacent sibling selector `+` to select all immediate children
// that are preceded by a sibling.
//
// Resources:
// https://developer.mozilla.org/en-US/docs/Web/CSS/Adjacent_sibling_selectors
// https://alistapart.com/article/axiomatic-css-and-lobotomized-owls
var getLayoutStylingRules = function getLayoutStylingRules(_ref) {
  var shouldWrap = _ref.shouldWrap,
      size = _ref.size;

  if (shouldWrap) {
    return (0, _styledComponents.css)(["flex-wrap:wrap;& > *:not(:last-child){margin-right:", "px !important;}"], size);
  }

  return (0, _styledComponents.css)(["& > * + *{margin-left:", "px !important;}"], size);
};

var StyledInlineChildren = _styledComponents["default"].div.withConfig({
  displayName: "InlineChildren__StyledInlineChildren",
  componentId: "sc-1awtuwe-0"
})(["", " display:flex;align-items:", ";justify-content:", ";", ""], _constants.BASE_STYLES, function (props) {
  return props.alignItems;
}, function (props) {
  return props.justifyContent;
}, getLayoutStylingRules);

var InlineChildren = function InlineChildren(_ref2) {
  var tag = _ref2.tag,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["tag", "children"]);

  return /*#__PURE__*/_react["default"].createElement(StyledInlineChildren, _extends({
    as: tag
  }, props), children);
};

InlineChildren.Sizes = _theming.Spacing;
InlineChildren.Justification = _constants.Justification;
InlineChildren.Alignment = _constants.Alignment;
InlineChildren.propTypes = {
  alignItems: _propTypes["default"].oneOf(Object.values(_constants.Alignment)),
  justifyContent: _propTypes["default"].oneOf(Object.values(_constants.Justification)),
  size: _propTypes["default"].oneOf(Object.values(InlineChildren.Sizes)),
  shouldWrap: _propTypes["default"].bool,
  tag: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  children: _propTypes["default"].node
};
InlineChildren.defaultProps = {
  alignItems: _constants.Alignment.Stretch,
  justifyContent: _constants.Justification.FlexStart,
  size: _constants.BASE_SPACING
};
var _default = InlineChildren;
exports["default"] = _default;